import { Component, Input } from '@angular/core';
import type { Field } from '../../model/formBuilderInterface';

@Component({
  selector: 'app-disclaimer-message',
  templateUrl: './disclaimer-message.component.html',
  styleUrls: ['./disclaimer-message.component.scss'],
  standalone: true
})
export class DisclaimerMessageComponent {
  @Input() field: Field;
}
